import {ImportingDataTypes} from "../../types";
import {createBooleanField, PreventionInvalidityCode} from "./shared";

/**
 * Preventative correction config for product property options import.
 */
export const preventativeInteraction = {
    datasourceId: ImportingDataTypes.productPropertyOptions,
    sections: [
        {
            sectionKey: 'invalidPropertyTitle',
            sectionTitle: 'Invalid Property Titles',
            invalidityCode: PreventionInvalidityCode.MISSING_REQUIRED_FIELDS,
            fields: [
                {
                    key: 'propertyTitle',
                    label: 'Property Title',
                    type: 'input',
                    modifyRow: (row, val) => ({...row, propertyTitle: val})
                }
            ]
        },
        {
            sectionKey: 'invalidPropertyOptionBooleans',
            sectionTitle: 'Invalid pre-defined values / multi-select flags',
            invalidityCode: PreventionInvalidityCode.INVALID_BOOLEAN,
            fields: [
                createBooleanField('hasPreDefinedValues', 'Has pre-defined values'),
                createBooleanField('isMultiSelect', 'Multi-select'),
            ],
        },
    ],
};
